export enum CustomTrackingEvent {
  DOWNLOAD_APP = "download_app",
  BOOK_APPOINTMENT = "book_appointment",
}
